import produce from 'immer';

export const FETCH_ORDER_PENDING = 'fetchOrder/get/pending';
export const FETCH_ORDER_FULFILLED = 'fetchOrder/get/fulfilled';
export const FETCH_ORDER_REJECTED = 'fetchOrder/get/rejected';

export const initialState = {
  loading: false,
  error: null,
};

/* eslint-disable default-case, no-param-reassign */
const fetchOrder = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_ORDER_PENDING:
        draft.loading = true;
        draft.error = false;
        break;
      case FETCH_ORDER_FULFILLED:
        draft.loading = false;
        break;
      case FETCH_ORDER_REJECTED:
        draft.loading = false;
        draft.error = action.error;
        break;
      default:
        break;
    }
  });
export default fetchOrder;
